<pdf-viewer
  [src]="pdfSrc"
  [original-size]="false"
  [render-text]="true"
  [fit-to-page]="true"
  [zoom-scale]="'page-fit'"
  style="display: block; max-height: 530px; overflow: auto"
></pdf-viewer>
